import API from "./api";

/** Persist explicit statutory wizard completion for dashboard setup progress. */
export async function markStatutorySetupConfigured() {
  const savedAt = new Date().toISOString();
  try {
    const res = await API.get("/organisation/me/hr-settings");
    const hr = res?.data?.hr_settings || {};
    const payroll = { ...(hr.payroll || {}) };
    if (payroll.statutory_completed === true && payroll.statutory_saved_at) {
      return payroll;
    }
    await API.patch("/organisation/me/hr-settings", {
      payroll: {
        ...payroll,
        statutory_completed: true,
        statutory_saved_at: savedAt,
      },
    });
    return { ...payroll, statutory_completed: true, statutory_saved_at: savedAt };
  } catch {
    return null;
  }
}
